/**
 * 课程分类
 */

import {
  get,
  post,
  put,
  del
} from '@/util/request'

/**
 * 根据Id查询
 * @param {*} Id
 * @returns
 */
export const SelectCourseCategoryById = (Id) => {
  return get('/api/app/CourseCategory?CurrentId=' + Id);
}

/**
 * 根据类别Id获取到它的上级分类及上上级分类
 * @param {*} Id
 * @returns
 */
export const GetCourseCategoryListById = (Id) => {
  return get('/api/app/CourseCategory/' + Id + '/courseCategoryListById');
}

/**
 * 新增数据记录
 * @param {*} data
 * @returns
 */
export const AddCourseCategory = (data) => {
  return post('/api/app/CourseCategory', data, {});
}

/**
 * 更新数据记录
 * @param {*} data
 * @returns
 */
export const ModifyCourseCategory = (data) => {
  return put('/api/app/CourseCategory', data, {});
}

/**
 * 分页获取课程分类
 * @param {*} data
 * @returns
 */
export const GetDataCourseCategoryList = (data) => {
  return post('/api/app/CourseCategory/list', data, {});
}

/**
 * 删除记录
 * @param {*} id
 * @returns
 */
export const DeleteCourseCategory = (id) => {
  return del('/api/app/CourseCategory/' + id, {}, {});
}

/**
 * 获取所有的二级分类
 * @param {*} data
 * @returns
 */
export const GetDataCourseCategory2 = () => {
  let data = {
    "pageSize": 10000,
    "pageIndex": 1,
    "queryModel": {
      "levlel": 2
    }
  }
  return post('/api/app/CourseCategory/list', data, {});
}